(function () {
  const section = document.querySelector('.featured-products');
  if (!section) return;

  const gridWrap = section.querySelector('.featured-products__grid-wrap');
  const grid = section.querySelector('.featured-products__grid');
  const tabs = section.querySelectorAll('.featured-products__tab');
  const limit = parseInt(section.dataset.limit || '8');

  if (!gridWrap || !grid) return;

  function setLoading(state) {
    gridWrap.classList.toggle('is-loading', state);
  }

  function formatMoney(amount) {
  const value = Number(amount);

  if (isNaN(value)) return '$0.00';

  return value.toLocaleString('es-MX', {
    style: 'currency',
    currency: 'MXN',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
}

  function getImageUrl(product) {
    if (product.featured_image) return product.featured_image;
    if (product.images && product.images.length) {
      const img = product.images[0];
      return typeof img === 'string' ? img : (img.src || '');
    }
    return '';
  }

  function refreshCartBubble() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        const bubble = document.querySelector('.cart-count-bubble span[aria-hidden]');
        if (bubble) bubble.textContent = cart.item_count;
        const cartBubble = document.querySelector('.cart-count-bubble');
        if (cartBubble) cartBubble.removeAttribute('hidden');
      });
  }

  function openCartDrawer() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.open();
    }
  }

  window.addToCart = function (variantId, btn) {
    btn.disabled = true;
    btn.classList.add('is-loading');

    // Step 1 — add to cart
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        setTimeout(function () {
          btn.classList.remove('is-added');
          btn.disabled = false;
        }, 1500);

        // Step 2 — fetch updated drawer HTML
        return fetch('/?section_id=cart-drawer');
      })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        const tmp = document.createElement('div');
        tmp.innerHTML = html;

        // Replace entire cart-drawer-items content
        const newDrawerItems = tmp.querySelector('cart-drawer-items');
        const existingDrawerItems = document.querySelector('cart-drawer-items');
        if (newDrawerItems && existingDrawerItems) {
          existingDrawerItems.outerHTML = newDrawerItems.outerHTML;
        } else {
          const newItems = tmp.querySelector('#CartDrawer-CartItems');
          const existingItems = document.querySelector('#CartDrawer-CartItems');
          if (newItems && existingItems) existingItems.innerHTML = newItems.innerHTML;
        }

        const newFooter = tmp.querySelector('#CartDrawer-Footer');
        const existingFooter = document.querySelector('#CartDrawer-Footer');
        if (newFooter && existingFooter) existingFooter.innerHTML = newFooter.innerHTML;

        refreshCartBubble();

        // Open drawer
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        }
      })
      .catch(function () {
        btn.disabled = false;
        btn.classList.remove('is-loading');
      });
  };

  function renderProducts(products) {
    if (!products.length) {
      grid.innerHTML = '<p style="color:var(--color-text-muted);font-size:14px;padding:2rem 0;">No hay productos en esta colección.</p>';
      return;
    }

    grid.innerHTML = products.slice(0, limit).map(function (p) {
      const imgUrl = getImageUrl(p);
      const imgHtml = imgUrl
        ? '<img src="' + imgUrl + '" alt="' + (p.title || '').replace(/"/g, '&quot;') + '" loading="lazy">'
        : '<div class="product-card__image-placeholder"><svg viewBox="0 0 24 24" fill="none" stroke="#b0bec5" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg></div>';

      const onSale = p.compare_at_price_min && parseInt(p.compare_at_price_min) > parseInt(p.price_min);
      const discount = onSale
        ? Math.round((parseInt(p.compare_at_price_min) - parseInt(p.price_min)) / parseInt(p.compare_at_price_min) * 100)
        : 0;

      const badge = onSale
        ? '<span class="product-card__badge product-card__badge--sale">-' + discount + '%</span>'
        : '';

      const comparePrice = onSale
        ? '<span class="product-card__price-compare">' + formatMoney(p.compare_at_price_min) + '</span>'
        : '';

      const variantId = p.variants && p.variants[0] ? p.variants[0].id : '';
      const productUrl = p.url || ('/products/' + p.handle);

      const cartBtn = variantId
        ? '<button class="product-card__cart-btn" aria-label="Agregar al carrito" onclick="event.preventDefault();event.stopPropagation();window.addToCart(' + variantId + ',this)">'
          + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 001.99 1.61h9.72a2 2 0 001.99-1.61L23 6H6"/></svg>'
          + '</button>'
        : '';

        console.log( p.variants[0].price );

      return '<a href="' + productUrl + '" class="product-card">'
        + '<div class="product-card__image-wrap">'
          + imgHtml
          + badge
          + '<div class="product-card__hover-actions">' + cartBtn + '</div>'
        + '</div>'
        + '<div class="product-card__body">'
          + (p.vendor ? '<p class="product-card__vendor">' + p.vendor + '</p>' : '')
          + '<p class="product-card__title">' + p.title + '</p>'
          + '<div class="product-card__price">'
            + '<span class="product-card__price-current">' + formatMoney(p.variants[0].price) + '</span>'
            + comparePrice
          + '</div>'
        + '</div>'
      + '</a>';
    }).join('');
  }

  function loadCollection(handle, tabEl) {
    setLoading(true);

    fetch('/collections/' + handle + '/products.json?limit=' + limit)
      .then(function (r) {
        if (!r.ok) throw new Error('Error ' + r.status);
        return r.json();
      })
      .then(function (data) {
        renderProducts(data.products || []);

        tabs.forEach(function (t) {
          t.classList.remove('featured-products__tab--active');
          t.setAttribute('aria-selected', 'false');
        });
        tabEl.classList.add('featured-products__tab--active');
        tabEl.setAttribute('aria-selected', 'true');

        setLoading(false);
      })
      .catch(function (err) {
        console.error('Featured products error:', err);
        setLoading(false);
      });
  }

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      if (tab.classList.contains('featured-products__tab--active')) return;
      const handle = tab.dataset.collection;
      if (!handle) return;
      loadCollection(handle, tab);
    });
  });
})();